import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-instructions-modal',
  templateUrl: './instructions-modal.component.html',
  styleUrls: ['./instructions-modal.component.css']
})

export class InstructionsModalComponent {
  @Input() modalId: string = 'instructionsModal';
  @Input() webtestHTML: SafeHtml = '';
  @Input() companyHTML: SafeHtml = '';
  @Input() examHTML: SafeHtml = '';
  @Input() examId: number;
  @Input() examName: string = '';
  @Input() company: string = '';
  @Input() viewMode: boolean = false;
  
  @Output() startExam = new EventEmitter<boolean>();
  @Output() cancelExam = new EventEmitter<void>();
  
  confirmed: boolean = false;
  @ViewChild('instructionsModal') instructionsModal: TemplateRef<any>;

  constructor(public languageService: LanguageService, private modalService: NgbModal) {    
  }

  get language() {
    return this.languageService.language;
  }

  getHTMLIDRef(name: string, id: any) {
    return `#collapse${name}${id}`;
  }
  getHTMLIDParent(id: any) {
    return `#instructionaccordion${id}`;
  }
  getHTMLIDAria(name: string, id: any) {
    return `#${name}${id}`;
  }

  confirmationchecked(event: any): void {
     if (event.target.checked) {
      this.confirmed = true;
    }
    else {
      this.confirmed = false;
    }
  }

  gotoexam(confirmed: boolean): void {
    if (confirmed) {
      this.startExam.emit(true);
    }
  }

  resumeinterval(): void {
    this.cancelExam.emit();
  }

  openModal() {
    const modalOptions: NgbModalOptions = {
      backdrop: this.viewMode ? true : 'static',
      keyboard: this.viewMode,
      ariaLabelledBy: 'modalTitleId' + this.examId,
      ariaDescribedBy: 'modalDescId' + this.examId,
      size: 'xl'
    };

    this.modalService.open(this.instructionsModal, modalOptions);
  }
}
